export function navigateWithOrigin(navigate, path, options = {}) {
  navigate(path, {
    ...options,
    state: {
      ...options.state,
      origin: window.location.pathname,
    },
  })
}
